// noinspection GraphQLUnresolvedReference

import { gql } from "graphql-request";

export const GetStateResult = gql`
    mutation ExecuteGetStateModelPlot (
        $inInfraFlag: String,
        $inState: String
        $inSource: String,
        $inResourceGroupID: String,
        $inSuperSectorID: Int,
        $inProjectTypeID: String,
        $inPLEMGroupID: Int,
        $inMasterTypeID: Int,
        $inLevel1GroupID: Int,
        $inLevel2GroupID: Int,
        $inFundingMode: String
        $inUserSID: UUID
    ) {
        executeGetStateModelPlot(
            inInfraFlag: $inInfraFlag
            inState: $inState
            inSource: $inSource
            inResourceGroupID: $inResourceGroupID
            inSuperSectorID: $inSuperSectorID
            inProjectTypeID: $inProjectTypeID
            inPLEMGroupID: $inPLEMGroupID
            inMasterTypeID: $inMasterTypeID
            inLevel1GroupID: $inLevel1GroupID
            inLevel2GroupID: $inLevel2GroupID
            inFundingMode: $inFundingMode
            inUserSID: $inUserSID
        ) {
            Month
            ResourceGroupID
            ResourceGroup
            sum_value
            sum_unit
        }
    }
`;
